<template>
  <router-view />

  <v-dialog
    v-model="dialog.show"
    max-width="450"
  >
    <v-card>
      <v-card-title class="text-h6">
        {{ dialog.title }}
      </v-card-title>

      <v-card-text>
        {{ dialog.message }}
      </v-card-text>

      <v-card-actions>

        <v-spacer />

        <v-btn
        color="black"
          @click="goDashboard"
        >
          OK
        </v-btn>
        <!-- <v-btn
          color="primary"
          @click="dialog.close()"
        >
          OK
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue"
import { useDialogStore } from './store/dialog'
import { useRouter } from "vue-router"

const dialog = useDialogStore()
const accessDeniedDialog = ref(false)
const router = useRouter()
let currentVersion = null
let versionChecker = null

const loadCurrentVersion = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`)
    const data = await res.json()

    currentVersion = data.version
  } catch (error) {
    console.error(error)
  }
}

const checkForUpdate = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`)
    const data = await res.json()

    if (currentVersion && currentVersion !== data.version) {
      window.location.reload()
    }
  } catch (error) {
    console.error(error)
  }
}

onMounted(async () => {
  await loadCurrentVersion()

  versionChecker = setInterval(checkForUpdate, 60000)
})

onUnmounted(() => {
  clearInterval(versionChecker)
})

const goDashboard = () => {
  accessDeniedDialog.value = false
  router.push("/dashboard")
  dialog.close()
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap');

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #64cf69;
  margin-top: 0;
}
</style>
<!-- <template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #64cf69;
  margin-top: 0px;
}
</style> -->
